import React, { useEffect } from 'react';

import styles from './ServerError.module.scss';

import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { useMixpanel } from 'react-mixpanel-browser';

import Button from '../../common/Button';

export function ServerError() {
  const mixpanel = useMixpanel();

  useEffect(() => {
    reportBusinessActionToMixpanel(mixpanel, 'server-error-page', { href: window.location.href });
  }, [mixpanel]);

  return (
    <div className={styles.container}>
      <h1>There was a problem. Please try again.</h1>
      <h3>
        <Button text="Refresh" onClick={() => window.location.reload()} />
      </h3>
    </div>
  );
}
